import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEnvelopeSolid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M34.625 6.5C36.4883 6.5 38 8.01102 38 9.875C38 10.9367 37.5008 11.9352 36.65 12.575L21.35 24.05C20.5484 24.6477 19.4516 24.6477 18.65 24.05L3.35 12.575C2.50013 11.9352 2 10.9367 2 9.875C2 8.01102 3.51102 6.5 5.375 6.5H34.625ZM17.3 25.85C18.9031 27.0523 21.0969 27.0523 22.7 25.85L38 14.375V29C38 31.482 35.982 33.5 33.5 33.5H6.5C4.01445 33.5 2 31.482 2 29V14.375L17.3 25.85Z" })
});
export default SvgEnvelopeSolid;
